<script setup lang="ts">
import { ref } from 'vue'
import { type DialogOptions } from '@/composables/useDialog'


const isOpen = ref(false)
const options = ref<DialogOptions>({
  title: '',
  message: '',
  type: 'alert'
})
const resolvePromise = ref<((value: boolean) => void) | null>(null)

const openDialog = (dialogOptions: DialogOptions): Promise<boolean> => {
  options.value = { ...dialogOptions }
  isOpen.value = true
  return new Promise((resolve) => {
    resolvePromise.value = resolve
  })
}

const handleConfirm = () => {
  isOpen.value = false
  resolvePromise.value?.(true)
}

const handleCancel = () => {
  isOpen.value = false
  resolvePromise.value?.(false)
}

defineExpose({
  openDialog
})
</script>

<template>
  <v-dialog
    v-model="isOpen"
    persistent
    max-width="500"
  >
    <v-card rounded="xl">
      <v-card-title class="text-h5">
        {{ options.title }}
      </v-card-title>

      <v-card-text>
        {{ options.message }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="options.type === 'confirm'"
          color="grey"
          variant="text"
          @click="handleCancel"
        >
          {{ options.cancelText || $t('cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          variant="text"
          @click="handleConfirm"
        >
          {{ options.confirmText || $t('ok') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
